import { Heading, Box, Image, IconButton, Text } from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import { useAsyncProgramPPQContext } from 'contexts/AsyncProgramPPQ/AsyncProgramPPQContext';
import React from 'react';

import mobileModalImage from '../../InitialQuizScreen/images/mobile-squares-bg-image.png';
import desktopModalImage from '../../InitialQuizScreen/images/squares-bg-image.png';

export type YouAreNotEligibleProps = {};

const BACKGROUND_COLOR = 'sky.dark';

/**
 * This component adds the You Are Not Eligible screen the pre-purchase quiz modal.
 */

// TODO:
// - move content to Contentful and fetch it from there
// - Use components/BulletPointWithIcon/BulletPointWithIcon for icons with background
function YouAreNotEligible(props: YouAreNotEligibleProps): JSX.Element {
  const { toggleModal, resetState, prevStep, setIsAnswerIneligible } =
    useAsyncProgramPPQContext();

  const handleModalClose = () => {
    toggleModal(false);
    resetState();
  };

  const handlePrevStep = () => {
    setIsAnswerIneligible(false);
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        backgroundColor={BACKGROUND_COLOR}
        justifyContent={['center', null, 'flex-start']}
        textAlign="center"
        height="100vh"
        position="relative"
        paddingTop={[5, null, 115]}
      >
        <IconButton
          colorScheme="whiteCS"
          size="sm"
          aria-label="previous-step"
          icon={<DynamicIcon icon="ArrowLeft" color="tints.uiGrey" />}
          onClick={handlePrevStep}
          width="40px"
          height="40px"
          position="absolute"
          top="20px"
          left={['24px', null, '70px']}
        />
        <IconButton
          colorScheme="whiteCS"
          size="sm"
          aria-label="close"
          icon={<DynamicIcon icon="X" color="tints.uiGrey" />}
          onClick={handleModalClose}
          width="40px"
          height="40px"
          position="absolute"
          top="20px"
          right={['24px', null, '70px']}
        />
        <Box
          paddingX="5"
          display="flex"
          flexDirection="column"
          alignItems="center"
          maxWidth={['100%', '700px']}
          gap={[4, null, 6]}
          marginTop={['auto', null, 0]}
        >
          <Text size="lg" color="terracotta.base">
            Our recommendation
          </Text>
          <Heading as="h1" size="2xl" color="tints.white">
            Seek in-person care
          </Heading>
          <Text size="xl" color="tints.white">
            We've reviewed your form and unfortunately, some of your information
            means that you are not currently eligible for a virtual care visit.
          </Text>
          <Text size="xl" color="tints.white">
            We recommend that you seek care with an in-person provider locally
            at a provider’s office, urgent care, or emergency department. If you
            are having a medical emergency, please call 911 or seek in-person
            care immediately.
          </Text>
        </Box>
        <Image
          src={mobileModalImage}
          alt="Image of a orange hexagon pattern" // Show this image on mobile. TODO: This is a temporary hack until we move the images to Contentful.
          display={['block', null, 'none']}
          maxWidth="100%"
          marginTop={['auto', null, 0]}
        />
      </Box>
      <Image
        alt="Image of a orange hexagon pattern" // Show this image on desktop. TODO: This is a temporary hack until we move the images to Contentful.
        bottom="0"
        display={['none', null, 'block']}
        maxWidth="1200px"
        position="absolute"
        src={desktopModalImage}
        right="0"
      />
    </>
  );
}

export default YouAreNotEligible;
